import { render, staticRenderFns } from "./appAdvertisementAddModule.vue?vue&type=template&id=89182872&scoped=true&"
import script from "./appAdvertisementAddModule.vue?vue&type=script&lang=js&"
export * from "./appAdvertisementAddModule.vue?vue&type=script&lang=js&"
import style0 from "./appAdvertisementAddModule.vue?vue&type=style&index=0&id=89182872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89182872",
  null
  
)

export default component.exports